module.exports = __webpack_public_path__ + "static/media/thomasberrens.9c103ab1.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/thomasberrens.webp
// module id = 902
// module chunks = 0